import React from 'react';
interface ArcQuotaProps {
  used: number;
  limit: number;
  tone?: 'light' | 'dark';
}

/**
 * Proposed replacement for the linear quota bar — the brand arc used as a
 * 270° gauge. Same information, more of the identity.
 */
export function ArcQuota({
  used,
  limit,
  tone = 'light'
}: ArcQuotaProps) {
  const radius = 34;
  const circumference = 2 * Math.PI * radius;
  const visible = circumference * 0.75;
  const ratio = Math.min(1, used / limit);
  const track = tone === 'dark' ? '#2a4433' : '#d1dabe';
  const value = tone === 'dark' ? '#7fe0ab' : '#14503a';
  const labelColor = tone === 'dark' ? 'text-white' : 'text-ink';
  const subColor = tone === 'dark' ? 'text-white/45' : 'text-ink-soft';
  return <div className="relative inline-flex h-[88px] w-[88px] items-center justify-center" data-id="element-169" data-mp="2gdgefiaovi8s">
      <svg viewBox="0 0 80 80" className="h-full w-full -rotate-[225deg]" data-id="element-170" data-mp="2ucy4s23mv3k9">
        <circle cx="40" cy="40" r={radius} fill="none" stroke={track} strokeWidth="7" strokeLinecap="round" strokeDasharray={`${visible} ${circumference}`} data-id="element-171" data-mp="2peemcbo909wn" />
        <circle cx="40" cy="40" r={radius} fill="none" stroke={value} strokeWidth="7" strokeLinecap="round" strokeDasharray={`${visible * ratio} ${circumference}`} data-id="element-172" data-mp="ixv93n5wmcyo" />
      </svg>
      <span className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-173" data-mp="wx4t6xx8dr7x">
        <span className={`font-mono text-[15px] font-medium ${labelColor}`} data-id="element-174" data-mp="11vy3khh8123v">
          {used}/{limit}
        </span>
        <span className={`font-mono text-[10px] ${subColor}`} data-id="element-175" data-mp="16m4ref3wsil2">services</span>
      </span>
    </div>;
}